import jwtDecode from 'jwt-decode';

import { hasEmbeddedParticipantSession } from '@/utils/hasEmbeddedParticipantSession';
import { TypedStorage } from '@/utils/TypedStorage';

export function useIsKinde() {
  // Even an expired handed-over token stays: `ParentAuthTokenProvider` refreshes it in place.
  if (hasEmbeddedParticipantSession()) {
    return false;
  }

  const viewerJwt = TypedStorage.get('viewer_jwt');

  if (viewerJwt) {
    const decodedJwt = jwtDecode(viewerJwt) as { exp?: number };
    // Honour legacy Askable token until it expires.
    if (decodedJwt?.exp && decodedJwt?.exp > Date.now() / 1000) {
      return false;
    }

    TypedStorage.remove('viewer_jwt');
  }
  return true;
}
